export const IMAGES = {
	fbb: {
		fillyPress:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Filly_Press.avif?v=1774541495",
		marcus:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/fbb_marcus.png?v=1774586960",
		logoBlack:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/logo_fbb_black.png?v=1774541493",
		logoWhite:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/logo_fbb_white.png?v=1774541493",
	},
	home: {
		hero: [
			"https://cdn.shopify.com/s/files/1/1080/6498/files/hero1.avif?v=1790979177",
			"https://cdn.shopify.com/s/files/1/1080/6498/files/hero2.avif?v=1790979177",
			"https://cdn.shopify.com/s/files/1/1080/6498/files/hero3.avif?v=1790979177",
			"https://cdn.shopify.com/s/files/1/1080/6498/files/hero4.avif?v=1790979178",
		],
		brandValues:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/EZ8A5350.jpg",
		jamesSprague:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/athlete1.png",
		alexGazan: "https://cdn.shopify.com/s/files/1/1080/6498/files/athlete2.png",
		eatLikeYourLifeDependsOnIt:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Eat_Like_Your_Life_Depends_On_It_Ice_Age_Meals_a8e91fcc-5341-4e5d-ba90-178ebf162630.webp",
		nickAndCrew:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Nick_and_the_crew.jpg",
		banner:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/1800x800-VS.webp",
	},
	about: {
		stackOfBooks:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Stack_Of_Books_Web.webp",
		paleoNickBooth:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/paleo-nicks_1.webp",
		sharkTank: {
			markCuban:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Ice_Age_Meals_Mark_Cuban_Shark_Tank.webp",
			serving:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Ice_Age_Meals_Shark_Tank_Serving_Butternut_Squash_Lasagna.webp",
			set: "https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Ice_Age_Meals_Shark_Tank.webp",
		},
		adventures: {
			alaska:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/paleo-nick-s-alaska-culinary-adventure.webp",
			nicaragua:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Nicaragua_Culinary_Adventure_Ice_Age_Meals_About_Web.webp",
			thailand:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/paleo-nick-s-culinary-adventure-thailand-2015.webp",
			dockDinner:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/Dock_Dinner.webp",
			dockSmoothies:
				"https://cdn.shopify.com/s/files/1/1080/6498/files/paleo-nick-s-iam-island-adventure-dock-smoothies.webp",
		},
		cookingLessons:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_Ice_Age_Culinary_Cooking_Lessons_Ice_Age_Meals_Web.webp",
		muskie:
			"https://cdn.shopify.com/s/files/1/1080/6498/files/Paleo_Nick_The_Bro_Muskie_IAM_Island.webp",
	},
} as const;
